/* ------------------------------------------------------------------
   LUS · email capture popup — timing and state only.

   The markup and the form come from snippets/lus-signup.liquid, because
   Shopify's customer form needs its own captcha token and that only
   happens on a real form submit. A hand-built form posted with fetch
   comes back 400 "Missing CAPTCHA token" and the subscriber is silently
   lost — which is exactly what the first version of this did.

   Rules, in order of how much damage breaking them does:
   1. Never a full-screen interstitial on a phone — Google demotes those
      in mobile search. The stylesheet turns it into a bottom bar there.
   2. Never on /cart, /checkout, /account or the policy pages. Someone
      who is paying should not be interrupted.
   3. Never on a visitor's first pages. It stays silent until they have
      opened MIN_VIEWS pages in this browsing session, so anyone who
      lands and leaves is never interrupted at all.
   4. Then it still waits: data-delay seconds on that page, or a scroll
      past SCROLL_AT of it, whichever comes first.
   5. Once shown and dismissed, silent for data-days days. Once actually
      subscribed, silent for good.

   There is deliberately NO exit-intent trigger any more. Moving the
   pointer up to the address bar, another tab or a bookmark fired it
   constantly, which is what made the popup feel like it followed you
   around the shop.

   The reveal uses a timeout rather than requestAnimationFrame: rAF is
   throttled in a background tab, and the dialog would then sit there at
   zero opacity with no way to finish opening.
   ------------------------------------------------------------------ */
(function () {
  var W = window, D = document;
  var KEY = 'lus_nl_v1';      // when it was last shown / whether subscribed
  var PV  = 'lus_nl_pv';      // pages opened in this session
  var MIN_VIEWS = 4;          // show from the fourth page onwards
  var SCROLL_AT = 0.6;        // or after 60% of a page
  var FOREVER = 3650;         // days of silence once subscribed

  var box = D.getElementById('lus-nlw');
  if (!box) return;

  var days = parseInt(box.getAttribute('data-days'), 10) || 120;
  var delay = parseInt(box.getAttribute('data-delay'), 10) || 75;
  // form.posted_successfully? only exists inside the {% form %} block, so
  // the success state is detected by the block Liquid rendered, not by a
  // class on this wrapper.
  var posted = !!box.querySelector('.nlw-done');
  var opener = null;
  var fired = false;

  function remember(done) {
    try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), done: !!done })); } catch (e) {}
  }

  function open() {
    if (!box.hidden) return;
    opener = D.activeElement;
    box.hidden = false;
    D.body.classList.add('nlw-open');
    setTimeout(function () {
      box.classList.add('on');
      var i = box.querySelector('input[type=email]');
      if (i && W.innerWidth > 760) { try { i.focus(); } catch (e) {} }
    }, 20);
    D.addEventListener('keydown', esc);
    remember(posted);
  }

  function close() {
    box.classList.remove('on');
    D.body.classList.remove('nlw-open');
    D.removeEventListener('keydown', esc);
    setTimeout(function () { box.hidden = true; }, 320);
    if (opener && opener.focus) { try { opener.focus(); } catch (e) {} }
  }

  function esc(ev) { if (ev.key === 'Escape') close(); }

  box.addEventListener('click', function (ev) {
    if (ev.target.hasAttribute && ev.target.hasAttribute('data-close')) close();
  });

  var copy = box.querySelector('.nlw-copy');
  if (copy) {
    copy.addEventListener('click', function () {
      var b = this, code = b.getAttribute('data-code');
      var done = function () { b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Copy'; }, 1800); };
      try { navigator.clipboard.writeText(code).then(done, done); } catch (e) { done(); }
    });
  }

  // Came back from a successful signup — show the code straight away and
  // tidy the query string so a refresh does not re-open it.
  if (posted) {
    box.classList.add('ok');
    remember(true);
    open();
    try {
      if (/customer_posted=true/.test(location.search)) {
        var q = location.search.replace(/[?&]customer_posted=true/, '');
        if (q && q[0] === '&') q = '?' + q.slice(1);
        history.replaceState({}, '', location.pathname + q);
      }
      if (W.gtag) W.gtag('event', 'sign_up', { method: 'popup' });
    } catch (e) {}
    return;
  }

  // 2. pages where it must stay quiet
  if (/\/(cart|checkout|account|challenge|policies)(\/|$)/.test(location.pathname)) return;

  // 5. already shown, dismissed or subscribed
  try {
    var seen = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (seen && seen.t) {
      var quiet = seen.done ? FOREVER : days;
      if (Date.now() - seen.t < quiet * 864e5) return;
    }
  } catch (e) {}

  // 3. count this page view and stay silent until the visitor has really
  //    been looking around. sessionStorage, so a new visit starts over.
  var views = 1;
  try {
    views = (parseInt(sessionStorage.getItem(PV), 10) || 0) + 1;
    sessionStorage.setItem(PV, String(views));
  } catch (e) {}
  if (views < MIN_VIEWS) return;

  // 4. and even then, only after time on the page or a real scroll
  function fire() {
    if (fired) return;
    fired = true;
    W.removeEventListener('scroll', onScroll);
    open();
  }
  function onScroll() {
    var h = D.documentElement.scrollHeight - W.innerHeight;
    if (h > 0 && W.scrollY / h > SCROLL_AT) fire();
  }
  W.addEventListener('scroll', onScroll, { passive: true });
  setTimeout(fire, delay * 1000);
})();
